import './BidNewCard.css';
import './BidNewCardSkeleton.css';

export default function BidNewCardSkeleton() {
  return (
    <div className="bid-new-card">
      {/* Image Placeholder */}
      <div className="bid-new-card-image-section">
        <div className="bid-card-new-skeleton bid-card-new-skeleton-box"></div>
      </div>

      {/* Content Wrapper */}
      <div className="bid-new-card-image-section-wrapper">
        <div className="bid-new-card-content-section">

          <div className="bid-new-card-text-section-skeleton">

            <span className="bid-card-new-skeleton bid-card-new-skeleton-circle small"></span>
            <span className="bid-card-new-skeleton bid-card-new-skeleton-line short"></span>

            <span className="bid-card-new-skeleton bid-card-new-skeleton-line medium"></span>

            <span className="bid-card-new-skeleton bid-card-new-skeleton-line long"></span>
          
          </div>

          {/* Right Side */}
          <div className="bid-new-card-about-text-section">
            <div className="pnats-icon-wrapper">
              <div className="bid-card-new-skeleton bid-card-new-skeleton-circle small"></div>
              <div className="bid-card-new-skeleton bid-card-new-skeleton-circle small"></div>
            </div>

            <div className="pnats-icon-wrapper-adult">
              <h1 className="bid-card-new-skeleton bid-card-new-skeleton-line short"></h1>
              <h4 className="bid-card-new-skeleton bid-card-new-skeleton-line medium"></h4>
              <h5 className="bid-card-new-skeleton bid-card-new-skeleton-line medium"></h5>
            </div>

            <div className="pnats-icon-wrapper-kid">
              <p className="bid-card-new-skeleton bid-card-new-skeleton-line short"></p>
              <span className="bid-card-new-skeleton bid-card-new-skeleton-line tiny"></span>
            </div>
          </div>
        </div>

        {/* Button */}
        <div className="bid-new-card-text-section-button">
          <div className="bid-card-new-skeleton bid-card-new-skeleton-button"></div>
        </div>
      </div>
    </div>
  );
}
